import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Gapped } from '@skbkontur/react-ui';
import { DatePickerISO } from '../DatePickerISO';
export const DatePeriodField = ({ onStartDateChange, onEndDateChange, dateStart, dateEnd, dateStartValidationInfo, dateEndValidationInfo, }) => {
    return (_jsxs(Gapped, { gap: 8, children: [_jsx(DatePickerISO, { width: 112, value: dateStart, onValueChange: onStartDateChange, validationInfo: dateStartValidationInfo }), "\u2014", _jsx(DatePickerISO, { width: 112, value: dateEnd, onValueChange: onEndDateChange, validationInfo: dateEndValidationInfo })] }));
};
